// extracted by mini-css-extract-plugin
export default {"header":"Header_header__VkbD6","landscape":"Header_landscape__Hp4Fs","gif":"Header_gif__qI2Eh","infoPanel":"Header_infoPanel__dXQOE","infoText":"Header_infoText__S2nOs"};